<template>
  <div class="AlertComponent">
    <b-modal v-model="isAlert" :no-close-on-esc="alertObject.noCloseOnEsc"
      :no-close-on-backdrop="alertObject.noCloseOnBackdrop" :title="alertObject.title"
      :header-bg-variant="theme.headerBgVariant" :header-text-variant="theme.headerTextVariant"
      :body-bg-variant="theme.bodyBgVariant" :body-text-variant="theme.bodyTextVariant"
      :footer-bg-variant="theme.footerBgVariant" :footer-text-variant="theme.footerTextVariant" :size="alertObject.size"
      :hide-header-close="hideHeaderClose">
      <b-container v-if="alertObject.type == 'info'" fluid>
        <p>{{alertObject.text}}</p>
        <p>{{alertObject.text2}}</p>
      </b-container>
      <b-container v-if="alertObject.type == 'question'" fluid>
        <p>{{alertObject.text}}</p>

      </b-container>
      <b-container v-if="alertObject.type == 'openrepo'" fluid>
        <p>{{ alertObject.text }}</p>

      </b-container>
      <b-container v-if="alertObject.type == 'withdraw'" fluid>
        <p>{{alertObject.text}}</p>

      </b-container>
      <!-- <b-container v-if="alertObject.type == 'notifications'" fluid>
         <p>{{alertObject.text}}</p>
         <NotificationTableComponent ></NotificationTableComponent>

       </b-container> -->
      <b-container v-if="alertObject.type == 'placing'" fluid>
        <p>{{alertObject.text}}</p>

      </b-container>
      <b-container v-if="alertObject.type == 'waiting'" fluid>
        <p>{{alertObject.text}}</p>

      </b-container>
      <b-container v-if="alertObject.type == 'sure'" fluid>
        <p>{{alertObject.text}}</p>

      </b-container>
      <b-container v-if="alertObject.type == 'import'" fluid>

        <p>{{alertObject.text}}</p>
        <form @submit.prevent="yes" id="fileform" action="" method="get" class="form-example">
          <div class="form-example">
            <label>File</label>
            <input type="file" id="file" name="file" accept="image/png, image/jpeg">
          </div>


        </form>



      </b-container>


      <div slot="modal-footer" class="w-100">
        <span v-if="alertObject.buttons == 3">
          <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="button3">
            Cancel
          </b-btn>
          <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="button2">
            Local
          </b-btn>
          <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="button1">
            Remote
          </b-btn>


        </span>
        <span v-if="alertObject.buttons == 2">

          <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="no">
            No
          </b-btn>
          <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="yes">
            Yes
          </b-btn>
        </span>
        <span v-if="alertObject.buttons == 1">
          <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="OK">
            OK
          </b-btn>

        </span>
        <span v-if="alertObject.buttons == 0">
          <b-progress :value="100" variant="success" :animated="true" class="mb-3"></b-progress>

        </span>
      </div>
    </b-modal>
  </div>
</template>

<script>
import NotificationTableComponent from "@/components/shared/NotificationTableComponent"

export default {
  components: {

    NotificationTableComponent
  },
  data () {
    return {
      name: 'AlertComponent',
      filter: {},
      options: [
        { text: 'Dark', value: 'dark' },
        { text: 'Light', value: 'light' },

      ],
      selectedSkinVariant: this.$store.getters.s_skinVariant,
      variants: [
        'primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'
      ],

      hideHeaderClose: true,
    }
  },
  computed: {
    
    isAlert:{

      get() {
        return this.$store.getters.isAlert
      },
      set(value) {

        //this.$store.commit('SHOWALERT', false);
      },
    },
    alertObject(){

      let o = this.$store.getters.alertObject;
      if (o.noCloseOnBackdrop == undefined){
        o.noCloseOnBackdrop = false;
      }
      if (o.noCloseOnEsc == undefined){
        o.noCloseOnEsc = false;
      }

      return o;
    },
    theme(){

      const obj = {};
      if (this.$store.getters.s_skinVariant == "light"){
        obj.headerBgVariant = 'light';
        obj.headerTextVariant = 'dark';
        obj.bodyBgVariant = 'white';
        obj.bodyTextVariant = 'dark';
        obj.footerBgVariant = 'light';
        obj.footerTextVariant = 'dark';

        obj.btnVariant = 'dark';

      }else if (this.$store.getters.s_skinVariant == "dark"){
        obj.headerBgVariant = 'dark';
        obj.headerTextVariant = 'light';
        obj.bodyBgVariant = 'dark';
        obj.bodyTextVariant = 'light';
        obj.footerBgVariant = 'dark';
        obj.footerTextVariant = 'light';

        obj.btnVariant = 'light';
      }
      return obj;
    }
    
  },
  created() {

    
    
  },
  watch: {
    isAlert: function (newVal, oldVal) {
      
      if (newVal == true){
        
        let vue = this;

        setTimeout(function () {

          let fade = document.getElementsByClassName("modal fade");
         
          fade[0].addEventListener("click", function(e){
            if (e.target.className == "modal fade show"){
              vue.$store.dispatch("hideAlert");
            }
            
          })

        },1000)

      }
    }
  },
  methods: {
    button1: function () {
      this.$store.dispatch("hideAlert");



      if (this.alertObject.func1 != "") {

        this.alertObject.func1(this);
      }


    },
    button2: function () {
      this.$store.dispatch("hideAlert");



      if (this.alertObject.func2 != "") {

        this.alertObject.func2(this);
      }


    },
    button3: function () {
      this.$store.dispatch("hideAlert");

      if (this.alertObject.func3 != "") {
        this.alertObject.func3(this);
      }


    },
    yes: function(){
      this.$store.dispatch("hideAlert");

      

      if (this.alertObject.funcYes != ""){
        
        this.alertObject.funcYes(this);
      }


    },
    no: function(){
      this.$store.dispatch("hideAlert");
      
      if (this.alertObject.funcNo != ""){
        this.alertObject.funcNo(this);
      }


    },
    OK: function(){
      this.$store.dispatch("hideAlert");

      
      if (this.alertObject.funcOk != ""){
        this.alertObject.funcOk(this);
      }


    },
    
  }
}
</script>
<style scoped>
  .modal-content {
    max-width: 1800px;
    margin: 1rem auto;
  }
  .btn{
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/AlertComponent.vue